     
      <ul class="navbar-nav mb-0 ms-lg-n3 me-auto">
        <!-- Left aligned nav items -->
        <li class="nav-item" *ngIf="isAuthenticated && isDriver && hasAgreedToTerms && !isCsr">
          <a 
            class="nav-link"
            [class.active]="route === '/driverDashboard'"
            (click)="navigateToDriverDashboard()"
            [ariaLabel]="'navbar_dashboard_link' | translator:'base'"
            name="driverDashboardLink"
            id="driverDashboardLink" 
            tabindex="0" 
          >
            <i
              class="fas fa-tachometer-alt me-1"
              aria-hidden="true"
            ></i>
            <span [innerHtml]="'navbar_dashboard_link' | translator:'base'">
              Dashboard
            </span>
          </a>
        </li>
        <li 
        class="nav-item" 
          *ngIf="isAuthenticated && isAccountHolder && hasAgreedToTerms && !isCsr"
        >
          <a 
            class="nav-link"
            [class.active]="route === '/dashboard'"
            (click)="navigateToAccountHolderDashboard()"
            [ariaLabel]="'navbar_dashboard_link' | translator: 'base'"
            name="ahDashboardLink"
            id="ahDashboardLink"
            tabindex="0" 
          >
            <i
              class="fas fa-tachometer-alt me-1"
              aria-hidden="true"
            ></i>
            <span [innerHtml]="'navbar_dashboard_link' | translator: 'base'">
              Dashboard
            </span>
          </a>
        </li>
        <li 
          class="nav-item" 
          *ngIf="isAuthenticated && isAccountHolder && hasAgreedToTerms && !isCsr"
        >
          <a 
            class="nav-link"
            [class.active]="route === '/auditDashboard'"
            (click)="navigateToAuditDashboard()"
            [ariaLabel]="'navbar_audit_dashboard_link' | translator: 'base'"
            name="auditDashboard"
            id="auditDashboard"
            tabindex="0" 
          >
            <span [innerHtml]="'navbar_audit_dashboard_link' | translator: 'base'">
              Audits
            </span>
          </a>
        </li>
        <li 
          class="nav-item" 
          *ngIf="isAuthenticated && (isAccountHolder || isDriver) && hasAgreedToTerms && !isCsr && showMVRByState"
        >
          <a 
            class="nav-link"
            [class.active]="route === '/MvrByState'"
            (click)="navigateToStateMVR()"
            [ariaLabel]="'navbar_mvr_state_dashboard_link' | translator: 'base'"
            name="stateMVR"
            id="stateMVR"
            tabindex="0" 
          >
            <span [innerHtml]="'navbar_mvr_state_dashboard_link' | translator: 'base'">
              MVR by State
            </span>
          </a>
        </li>
        <li 
          class="nav-item" 
          *ngIf="isAuthenticated && (isDriver) && hasAgreedToTerms && !isCsr"
        >
          <a 
            class="nav-link"
            [class.active]="route === '/monitor'"
            (click)="navigateToDriverMonitor()"
            [ariaLabel]="'psp_monitoring' | translator: 'base'"
            name="psp_monitor"
            id="psp_monitor"
            tabindex="0" 
          >
            <span [innerHtml]="'psp_monitoring' | translator: 'base'">
              PSP Monitoring
            </span>
          </a>
        </li>
        <li class="nav-item" *ngIf="isCsr">
          <a 
            class="nav-link"
            [href]="csrDashboardUrl"
            aria-label="CSR"
            name="csrDashboard"
            id="csrDashboard"
            tabindex="0" 
          >CSR</a>
        </li>	
        <li 
          class="nav-item" 
          *ngIf="isAuthenticated && isAdmin && hasAgreedToTerms && !isCsr"
        >
          <a 
            class="nav-link"
            [class.active]="route === '/userAccountAdmin' || route.includes('editAccountAdmin')"
            (click)="navigateToUserAccountAdmin()"
            [ariaLabel]="'Admin' | translator: 'base'"
            name="userAccountAdmin"
            id="userAccountAdmin"
            [innerHtml]="'Admin' | translator: 'base'"
            tabindex="0" 
          >Admin
          </a>
        </li>
        <li 
          ngbDropdown 
          class="nav-item dropdown" 
          *ngIf="isAuthenticated && showInvoices && hasAgreedToTerms && !isCsr"
        >
          <a 
            ngbDropdownToggle 
            class="nav-link dropdown-toggle" 
            id="paymentsDropdown" 
            role="button" 
            data-bs-toggle="dropdown" 
            aria-expanded="false" 
            tabindex="0" 
            [class.active]="route === '/billingReports' || route === '/billing-summary' || route === '/generic-statement' || route === '/single-paper-invoice' || route === '/invoice/activity' || route === '/payment'"
          >
            <span
              class="accountColor"
              [innerHtml]="'Billing' | translator: 'base'"
            >Billing</span>
          </a>
          <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li 
              ngbDropdownItem 
              [class.active]="route === '/billingReports' || route === '/billing-summary' || route === '/generic-statement' || route === '/single-paper-invoice'"
            >
              <a 
                class="dropdown-item" 
                [class.active]="route === '/billingReports' || route === '/billing-summary' || route === '/generic-statement' || route === '/single-paper-invoice'"
                [ariaLabel]="'BillingReports' | translator: 'base'"
                name="billingReports"
                id="billingReports"
                (click)="navigateToBillingReports()"
                tabindex="0" 
              >
                <i
                  class="fas fa-file-invoice-dollar me-1"
                  aria-hidden="true"
                ></i>
                <span [innerHtml]="'BillingReports' | translator: 'base'">Billing Reports</span>
              </a>
            </li>
            <li 
              ngbDropdownItem
              [class.active]="route === '/invoice'"
            >
              <a 
                class="dropdown-item"
                [class.active]="route === '/invoice'"
                [ariaLabel]="'InvoiceActivity' | translator: 'base'"
                name="invoiceActivity"
                id="invoiceActivity"
                (click)="navigateToInvoiceActivity()"
                tabindex="0" 
              >
                <i
                  class="fas fa-file-invoice-dollar me-1"
                  aria-hidden="true"
                ></i>
                <span id="InvoiceActivity" [innerHtml]="'InvoiceActivity' | translator: 'invoice'">Invoices</span>
              </a>
            </li>
            <li 
              ngbDropdownItem
              [class.active]="route === '/payment'"
            >
              <a 
                class="dropdown-item"
                [class.active]="route === '/payment'"
                [ariaLabel]="'PaymentMethodsHeader' | translator: 'base'"
                name="paymentMethods"
                id="paymentMethods"
                (click)="navigateToPaymentMethods()"
                tabindex="0" 
              >
                <i
                  class="fas fa-credit-card me-1"
                  aria-hidden="true"
                ></i>
                <span [innerHtml]="'PaymentMethodsHeader' | translator: 'base'">Payment Methods</span>
              </a>
            </li>
          
          </ul>
        </li>
        <li 
          ngbDropdown 
          class="nav-item dropdown" 
          [class.active]="route === '/wsAPI' || route === '/wsToken'"
          *ngIf="isAuthenticated && isAdmin && hasAgreedToTerms && !isCsr && !isIah"
        >
          <a 
            ngbDropdownToggle
            class="nav-link dropdown-toggle"
            [class.active]="route === '/wsAPI' || route === '/wsToken'"
            [ariaLabel]="'navbar_webservice_hover' | translator:'base'"
            name="webservice"
            id="webservice"
            role="button" data-bs-toggle="dropdown" aria-expanded="false"
            tabindex="0" 
          >
            <span
            [innerHtml]="'navbar_webservice_link' | translator:'base'"
              class="accountColor"
            >Web Service </span>
          </a>
          <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li 
              ngbDropdownItem
              [class.active]="route === '/wsAPI'"
            >
              <a 
                class="dropdown-item"
                [class.active]="route === '/wsAPI'"
                [ariaLabel]="'navbar_webservice_acc_request' | translator:'base'"
                name="requestWebServiceAccess"
                id="requestWebServiceAccess"
                (click)="navigateToUserWebServiceAccess()"
                tabindex="0" 
              >
                <i
                  class="fas fa-file-invoice-dollar me-1"
                  aria-hidden="true"
                ></i>
                <span [innerHtml]="'WSAPI_1' | translator:'webservice'">Request Web Service Access</span>
              </a>
            </li>
            <li 
              ngbDropdownItem
              [class.active]="route === '/wsToken'"
            >
              <a 
                class="dropdown-item"
                [class.active]="route === '/wsToken'"
                [ariaLabel]="'navbar_webservice_token_request' | translator:'base'"
                name="requestWebServiceToken"
                id="requestWebServiceToken"
                (click)="navigateToUserWebServiceToken()"
                tabindex="0" 
              >
                <i
                  class="fas fa-file-invoice-dollar me-1"
                  aria-hidden="true"
                ></i>
                <span [innerHtml]="'RequestTokenHeader' | translator: 'webservice'"  >Request an API Token</span>
              </a>
            </li>
            
          </ul>
        </li>
      </ul>
      <ul  class="navbar-nav mb-0 me-lg-n3">
        <!-- Right aligned nav items -->
        <li 
          class="nav-item start" 
          *ngIf="!isAuthenticated && !onSigninPage"
          [class.active]="route === '/signin'"
        >
          <button (click)="redirectToLoginGov()"
                 *ngIf="(route !== '/drivers' && route !== '/veterans' && route !== '/signin' && route !== '/women-drivers')" 
                  type="button"
                  id="loginSubmit"
                  name="loginSubmit"
                  class="btn btn-link nav-link">
                    <i class="fas fa-arrow-right-to-bracket me-1"
                    aria-hidden="true"></i>
                    <span [innerHtml]="'navbar_login_link' | translator:'base'">
                         Login
                    </span>
          </button>
        </li>
        <li 
          ngbDropdown 
          class="nav-item dropdown" 
          [class.active]="route === '/monitoring'"
          *ngIf="isAuthenticated" text="My account"
        >
          <!-- Using 'button-content' slot -->
          <a ngbDropdownToggle class="nav-link dropdown-toggle" [class.active]="route === '/monitoring'" id="loginsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" tabindex="0">
            <i class="fas fa-user me-1" aria-hidden="true"></i>
            <span [innerHtml]="'navbar_my_account_btn' | translator:'base'" class="accountColor">My account</span>
          </a>
          <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="loginsDropdown">
            <li ngbDropdownItem>
              <p class="dropdown-item mb-0">
                <strong [innerHtml]="'navbar_welcome_label' | translator:'base'">Welcome,</strong> {{ firstName }}&nbsp;{{ lastName }}&nbsp;
                <span *ngIf="isAdmin">(<span [innerHtml]="'Admin' | translator:'base'">Admin</span>)</span>&nbsp;
                <span *ngIf="isCsr">(CSR)&nbsp;<i class='far fa-smile'></i></span>
                <span *ngIf="!isDriver"><br><span [innerHtml]="'navbar_customer_id_label' | translator:'base'">Customer ID</span>:&nbsp;{{ customerId }}</span>
              </p>
            </li>
            <li ngbDropdownItem>
              <a
                (click)="logoff()"
                [ariaLabel]="'navbar_logout_btn' | translator:'base'"
                name="logoffLink"
                id="logoffLink" 
                class="dropdown-item"
                tabindex="0"
                role="button"
              >
                <i class='fas fa-sign-out-alt me-1'></i>
                <span [innerHtml]="'navbar_logout_btn' | translator:'base'">Logout</span>
              </a>
          </ul>
        </li>
        <!-- Chat button-->
        <li class="nav-item end">
          <a
            (click)="openZendeskChat()"
            class="btn btn-link nav-link"
            [ariaLabel]="'navbar_live_help' | translator:'base'"
            name="conversation-badge"
            id="conversation-badge"
            tabindex="0"
            role="button"
          >
            <i class="far fa-comments me-1" aria-hidden="true"></i>
            <span [innerHtml]="'navbar_live_help' | translator:'base'">Live Help</span>
          </a>
        </li> 
      </ul>